import * as ex from "excalibur";
import { Resources } from "./Resources";
import { Config } from "./config";

export class Player extends ex.Actor {
  constructor(x, y, endAnim) {
    super({
      x: x,
      y: y,
      width: 32,
      height: 32,
      radius: 10,
      collisionType: ex.CollisionType.Active,
    });
    this.lastDir = "down";
    this.cutScene = false;
    this.name = "player";
    this.playingAnim = false;
    this.endCallback = endAnim;
    this.loaded = false;
    this.footsteps = false;
    this.wearingVeil = true;
  }

  onInitialize(engine) {
    let playerSpriteSheet;
    if (this.wearingVeil) {
      playerSpriteSheet = ex.SpriteSheet.fromImageSource({
        image: Resources.CharVeil,
        grid: {
          spriteWidth: 32,
          spriteHeight: 32,
          rows: 12,
          columns: 20,
        },
      });
    } else {
      playerSpriteSheet = ex.SpriteSheet.fromImageSource({
        image: Resources.HeroSpriteSheetPng,
        grid: {
          spriteWidth: 32,
          spriteHeight: 32,
          rows: 12,
          columns: 20,
        },
      });
    }

    const shadowSprite = playerSpriteSheet.getSprite(0, 6);
    const shadow = new ex.Actor({ pos: new ex.Vector(0, 0), z: 2 });
    shadow.graphics.add("shadow", shadowSprite);
    shadow.graphics.use("shadow");
    this.addChild(shadow);

    const leftIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("left-idle", leftIdle);

    const rightIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("right-idle", rightIdle);

    const upIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("up-idle", upIdle);

    const downIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("down-idle", downIdle);

    const leftWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("left-walk", leftWalk);

    const rightWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("right-walk", rightWalk);

    const upWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("up-walk", upWalk);

    const downWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("down-walk", downWalk);
    const leftIdleBobble = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(1, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 6),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("leftIdleBobble", leftIdleBobble);
    this.shakeMites = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(5, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 6),
          duration: Config.PlayerFrameSpeed,
        },

        {
          graphic: playerSpriteSheet.getSprite(6, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 6),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 6),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("shakeMites", this.shakeMites);

    this.harvestBox = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(5, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(8, 7),
          duration: Config.PlayerFrameSpeed,
        },

        {
          graphic: playerSpriteSheet.getSprite(9, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(10, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(11, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(12, 7),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("harvestBox", this.harvestBox);

    const holdingMiteJar = playerSpriteSheet.getSprite(6, 6);
    this.graphics.add("holdingMiteJar", holdingMiteJar);
    this.addBox = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 7),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 7),
          duration: Config.PlayerFrameSpeed,
        },
      ],

      strategy: "loop",
    });
    this.graphics.add("addBox", this.addBox);
    this.holdingFrame = playerSpriteSheet.getSprite(6, 8);
    this.graphics.add("holdingFrame", this.holdingFrame);
    this.pickupFrame = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 8),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 8),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 8),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 8),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 8),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 8),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 8),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("pickupFrame", this.pickupFrame);

    this.turnExtractor = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 5),
          duration: 50,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 5),
          duration: 50,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 5),
          duration: 50,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 5),
          duration: 50,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 5),
          duration: 50,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 5),
          duration: 50,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 5),
          duration: 50,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("turnExtractor", this.turnExtractor);

    this.leftSmoke = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(8, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(9, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(10, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(11, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(12, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(13, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(14, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(15, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(16, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(17, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(18, 4),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(19, 4),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("left-smoke", this.leftSmoke);

    this.rightSmoke = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(8, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(9, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(10, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(11, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(12, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(13, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(14, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(15, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(16, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(17, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(18, 9),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(19, 9),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("right-smoke", this.rightSmoke);

    this.downSmoke = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(8, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(9, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(10, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(11, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(12, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(13, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(14, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(15, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(16, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(17, 10),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(18, 10),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("down-smoke", this.downSmoke);

    this.upSmoke = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 11),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 11),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 11),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 11),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 11),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 11),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 11),
          duration: Config.PlayerFrameSpeed,
        },
      ],
      strategy: "loop",
    });
    this.graphics.add("up-smoke", this.upSmoke);

    this.holdingExtractor = playerSpriteSheet.getSprite(0, 5);
    this.graphics.add("holdingExtractor", this.holdingExtractor);
    this.loaded = true;
    this.shakeMites &&
      this.shakeMites.events.on("loop", () => {
        this.playingAnim = false;
        this.graphics.use("holdingMiteJar");
        this.endCallback();
      });
    this.harvestBox &&
      this.harvestBox.events.on("loop", () => {
        this.playingAnim = false;
        this.graphics.use("leftIdleBobble");
        this.endCallback();
      });
    this.addBox &&
      this.addBox.events.on("loop", () => {
        this.playingAnim = false;
        this.graphics.use("leftIdleBobble");
        this.endCallback();
      });
    this.pickupFrame &&
      this.pickupFrame.events.on("loop", () => {
        this.playingAnim = false;
        this.graphics.use("holdingFrame");
        this.endCallback();
      });
    this.turnExtractor &&
      this.turnExtractor.events.on("loop", () => {
        this.playingAnim = false;

        this.graphics.use("holdingExtractor");
        this.endCallback();
      });
    this.leftSmoke &&
      this.leftSmoke.events.on("loop", () => {
        console.log("ended smokeLeft playerAnim");
        this.playingAnim = false;
        this.graphics.use("left-idle");
        this.endCallback();
      });
    this.rightSmoke &&
      this.rightSmoke.events.on("loop", () => {
        console.log("ended smokeright");
        this.playingAnim = false;
        this.graphics.use("right-idle");
        this.endCallback();
      });
    this.upSmoke &&
      this.upSmoke.events.on("loop", () => {
        console.log("ended smokeup");
        this.playingAnim = false;
        this.graphics.use("up-idle");
        this.endCallback();
      });
    this.downSmoke &&
      this.downSmoke.events.on("loop", () => {
        console.log("ended smokedown");
        this.playingAnim = false;
        this.graphics.use("down-idle");
        this.endCallback();
      });
  }
  doAnim(anim) {
    this.anim = anim;
    this.playingAnim = true;
  }
  // onPostUpdate() {
  //   this.addBox.on("end", () => {
  //     this.endAnim();
  //   });
  // }
  playSound() {
    if (!this.footsteps) {
      this.footsteps = true;
      Resources.Footsteps.stop();
      Resources.Footsteps.loop = true;
      Resources.Footsteps.play(0.07).then(() => {
        // this.footsteps = false;
      });
    }
  }
  stopSound() {
    this.footsteps = false;
    Resources.Footsteps.stop();
  }
  onPreUpdate(engine, elapsedMs) {
    this.vel = ex.Vector.Zero;
    if (!this.playingAnim) {
      switch (this.lastDir) {
        case "down":
          this.graphics.use("down-idle");
          break;

        case "up":
          this.graphics.use("up-idle");
          break;

        case "left":
          this.graphics.use("left-idle");
          break;

        case "right":
          this.graphics.use("right-idle");
          break;

        default:
          this.graphics.use("down-idle");
          break;
      }
    } else {
      this.graphics.use(this.anim);
    }

    if (!this.cutScene) {
      if (engine.input.keyboard.isHeld(ex.Keys.Right)) {
        this.vel = ex.vec(Config.PlayerSpeed, 0);
        this.graphics.use("right-walk");
        this.lastDir = "right";

        this.playSound();
      }
      if (engine.input.keyboard.wasReleased(ex.Keys.Right)) {
        this.stopSound();
      }
      if (engine.input.keyboard.isHeld(ex.Keys.Left)) {
        this.vel = ex.vec(-Config.PlayerSpeed, 0);
        this.graphics.use("left-walk");
        this.lastDir = "left";

        this.playSound();
      }
      if (engine.input.keyboard.wasReleased(ex.Keys.Left)) {
        this.stopSound();
      }
      if (engine.input.keyboard.isHeld(ex.Keys.Up)) {
        this.vel = ex.vec(0, -Config.PlayerSpeed);
        this.graphics.use("up-walk");
        this.lastDir = "up";

        this.playSound();
      }
      if (engine.input.keyboard.wasReleased(ex.Keys.Up)) {
        this.stopSound();
      }
      if (engine.input.keyboard.isHeld(ex.Keys.Down)) {
        this.vel = ex.vec(0, Config.PlayerSpeed);
        this.graphics.use("down-walk");
        this.lastDir = "down";
        this.playSound();
      }
      if (engine.input.keyboard.wasReleased(ex.Keys.Down)) {
        this.stopSound();
      }
    }
  }
}
